import {
  DATA_SERVICE_URL,
  Form as FormContainer
} from '@elfsight/widget-form-builder/widget';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../meta';
import { FormLayout } from './form-layout';
import { useGetFields } from './use-get-fields';

interface FormProps {
  isMobile?: boolean;
  spin: () => void;
}

export const Form = ({ isMobile, spin }: FormProps) => {
  const { widgetToken, integrationSettingsID } = useSettings();
  const fields = useGetFields();

  const formSettings = {
    fields,
    widgetToken,
    integrationSettingsID,
    submitAdditionalData: {
      type: meta.appAlias
    }
  };

  return (
    <FormContainer
      {...formSettings}
      submitUrl={`${DATA_SERVICE_URL}/public/resources/form-submissions/`}
    >
      <FormLayout
        isMobile={isMobile}
        fields={fields}
        formSettings={formSettings}
        spin={spin}
      />
    </FormContainer>
  );
};
